import { mixed, object, string } from 'yup';

export const selectSchema = <T extends {}>(value: T[]) =>
  object({
    value: mixed<T>().oneOf(value).required(),
    label: string().required(),
  });
